import { Icon } from "@/components/icon";
import { useTheme } from "@/theme/hooks";
import { cn } from "@/utils";
import { NavLink } from "react-router";

interface Props {
	size?: number | string;
	className?: string;
	clickable?: boolean;
}
function Logo({ size = 50, className, clickable = true }: Props) {
	const { themeTokens } = useTheme();

	const logoIcon = <Icon icon="solar:code-square-bold" color={themeTokens.color.palette.primary.default} size={size} />;

	if (!clickable) {
		return <div className={cn(className)}>{logoIcon}</div>;
	}

	return (
		<NavLink to="/" className={cn(className)}>
			{logoIcon}
		</NavLink>
	);
}

export default Logo;
